// extracted by mini-css-extract-plugin
export default {"layout":"FXH8a0Ux5zHHuTh","loader":"O0AGki3t1xkSBAR"};